import React, {useEffect} from 'react';
import {ActionModal, useErrorHandler, ErrorModal} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useFundraiser} from '../../../../entities';
import {useNavigate} from 'react-router';

interface DeleteFundraiserModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  fundraiserId: string;
}

export const DeleteFundraiserModal = ({open, setOpen, fundraiserId}: DeleteFundraiserModalProps) => {
  const {deleteFundraiserMutation} = useFundraiser({id: fundraiserId});
  const navigate = useNavigate();

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление сбора',
    title: 'Ошибка при удалении сбора',
  });

  useEffect(() => {
    if (deleteFundraiserMutation.error) {
      handleError(deleteFundraiserMutation.error as unknown as ApiError);
    }
  }, [deleteFundraiserMutation.error, handleError]);

  const handleSubmit = () => {
    deleteFundraiserMutation.mutate(undefined, {
      onSuccess: () => {
        setOpen(false);
        navigate('/fundraisings/appeals');
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteFundraiserMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление сбора'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этот сбор? Обратите внимание, что это действие безвозвратное{' '}
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
